import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Tc, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { HttpParams } from '@angular/common/http';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { UsuariosService } from '.././usuarios.service';
import {
    UsuarioMigracionItemResultsViewModel,
    WListaUsuariosMigracionItemViewModel,
    FilterSearchingWListaUsuariosMigracionItemViewModel,
} from '../usuarios.types';
import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'app-usuariosmigracion-list',
    templateUrl: './usuariosmigracion-list.component.html',
})
export class UsuariosMigracionListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultUsuariosMigracion: UsuarioMigracionItemResultsViewModel;

    listPerfilesUsuario: Tc[];
    listProvincias: Tc[];

    cols: any[];
    public selectedColumns: any[];
    visibilitySpinner: boolean = false;

    public isCollapsed = false;

    constructor(
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private usuariosService: UsuariosService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultUsuariosMigracion = new UsuarioMigracionItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Apellidos', header: 'Apellidos' },
            { field: 'NombreUsuario', header: 'Usuario Cexveg' },
            { field: 'NifCas', header: 'NIF' },
            { field: 'Email', header: 'Email' },
            { field: 'YaMigrado', header: 'Ya Migrado' },
            { field: 'Activo', header: 'Activo' },
        ];

        this.selectedColumns = this.cols;

        //Provincias
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        //Perfiles
        this.globalService.getPerfilesUsuario().subscribe(result => {
            this.listPerfilesUsuario = result;
        });

        this.form = this.fb.group({
            Nombre: '',
            Apellidos: '',
            NombreUsuario: '',
            NifCas: '',
            Email: '',
            Activo: true,
            EsUsuarioCexveg: false,
            IdPerfilUsuario: null,
            IdProvincia: null,
            Pendientes: EnumSiNoTodos.TODOS,
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        if (
            this.usuariosService.currentFilterUsuariosMigracion.Nombre != '' ||
            this.usuariosService.currentFilterUsuariosMigracion.Apellidos != '' ||
            this.usuariosService.currentFilterUsuariosMigracion.NombreUsuario != '' ||
            this.usuariosService.currentFilterUsuariosMigracion.NifCas != '' ||
            this.usuariosService.currentFilterUsuariosMigracion.Email != '' ||
            !this.usuariosService.currentFilterUsuariosMigracion.Activo ||
            this.usuariosService.currentFilterUsuariosMigracion.IdPerfilUsuario != null ||
            this.usuariosService.currentFilterUsuariosMigracion.IdProvincia != null ||
            this.usuariosService.currentFilterUsuariosMigracion.Pendientes != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                Nombre: this.usuariosService.currentFilterUsuariosMigracion.Nombre,
                Apellidos: this.usuariosService.currentFilterUsuariosMigracion.Apellidos,
                NombreUsuario: this.usuariosService.currentFilterUsuariosMigracion.NombreUsuario,
                NifCas: this.usuariosService.currentFilterUsuariosMigracion.NifCas,
                Email: this.usuariosService.currentFilterUsuariosMigracion.Email,
                Activo: this.usuariosService.currentFilterUsuariosMigracion.Activo,
                IdPerfilUsuario: this.usuariosService.currentFilterUsuariosMigracion.IdPerfilUsuario,
                IdProvincia: this.usuariosService.currentFilterUsuariosMigracion.IdProvincia,
                Pendientes: this.usuariosService.currentFilterUsuariosMigracion.Pendientes,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.usuariosService.currentFilterUsuariosMigracion.Nombre = this.form.value.Nombre;
        this.usuariosService.currentFilterUsuariosMigracion.Apellidos = this.form.value.Apellidos;
        this.usuariosService.currentFilterUsuariosMigracion.NombreUsuario = this.form.value.NombreUsuario;
        this.usuariosService.currentFilterUsuariosMigracion.NifCas = this.form.value.NifCas;
        this.usuariosService.currentFilterUsuariosMigracion.Email = this.form.value.Email;
        this.usuariosService.currentFilterUsuariosMigracion.Activo = this.form.value.Activo;
        this.usuariosService.currentFilterUsuariosMigracion.IdPerfilUsuario = this.form.value.IdPerfilUsuario;
        this.usuariosService.currentFilterUsuariosMigracion.IdProvincia = this.form.value.IdProvincia;
        this.usuariosService.currentFilterUsuariosMigracion.Pendientes = this.form.value.Pendientes;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('nombre', this.form.value.Nombre);
        params = params.append('apellidos', this.form.value.Apellidos);
        params = params.append('nombreUsuario', this.form.value.NombreUsuario);
        params = params.append('email', this.form.value.Email);
        params = params.append('nifCas', this.form.value.NifCas);
        params = params.append('activo', this.form.value.Activo);
        params = params.append('pendientes', this.form.value.Pendientes);
        params = params.append('idPerfilUsuario', this.form.value.IdPerfilUsuario);
        params = params.append('idProvincia', this.form.value.IdProvincia);

        this.loading = true;
        this.usuariosService.getUsuariosMigracionPagedByFilter(params).subscribe(result => {
            this.resultUsuariosMigracion = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Nombre: '',
            Apellidos: '',
            NombreUsuario: '',
            NifCas: '',
            Email: '',
            Activo: true,
            EsUsuarioCexveg: false,
            IdProvincia: null,
            IdPerfilUsuario: null,
            Pendientes: EnumSiNoTodos.TODOS,
        });

        this.searchingButton = false; //??

        this.isCollapsed = false;

        this.resultUsuariosMigracion = new UsuarioMigracionItemResultsViewModel();
    }

    onMigrarUsuario(item: WListaUsuariosMigracionItemViewModel) {
        this.confirmationService.confirm({
            message:
                '¿Está seguro de migrar a CEXVEG WEB el usuario con NIF: ' +
                item.NifCas +
                '?<br><br><strong>Tenga en cuenta que no podrá deshacer la operación</strong>.',
            accept: () => {
                this.onSubmit(item);
            },
        });
    }

    checkMigrarUsuario(rowData: WListaUsuariosMigracionItemViewModel) {
        return !rowData.YaMigrado;
    }

    onSubmit(item: WListaUsuariosMigracionItemViewModel) {
        this.usuariosService.migrateUsuario(item).subscribe({
            next: res => {
                if (res) {
                    this.addSuccessMessage('Usuario con NIF: ' + item.NifCas + ' registrado correctamente');

                    //Para recargar la búsqueda.
                    this.onSearchButton();
                } else {
                    this.addErrorMessage('Error al registrar el usuario');
                }
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    CreateModel() {
        let model: FilterSearchingWListaUsuariosMigracionItemViewModel = new FilterSearchingWListaUsuariosMigracionItemViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.usuariosService.exportUsuariosMigracion(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
